import themes from "devextreme/ui/themes";

class ThemeDocumentElement {
  constructor() {
    this.SetTheme = this.SetTheme.bind(this);
  }

  SetTheme(theme) {
    if (theme === "theme-dark") {
      themes.current("generic.dark.compact");
    } else if (theme === "theme-light") {
      themes.current("generic.light.compact");
    }
  }
}

export default ThemeDocumentElement;
